import React from 'react';
import { Helmet } from 'react-helmet';
import { PropTypes } from 'prop-types';
import { AppStore } from 'stores/App.store';
import GlobalMetaTagsStore from 'stores/GlobalMetaTags.store';
import { inject, observer } from 'mobx-react';
import compose from 'lodash/flowRight';
import LanguageService from '../../services/Language.service';

const InjectMetaTags = (props) => {
  const {
    title,
    description,
    ogImage,
    ogType,
    metaKeywords,
    noIndex,
    pathname,
    appStore: { currentLanguage },
    globalMetaTagsStore: { metaTags },
  } = props;
  const { origin, pathname: pathnameLocation } = document.location;

  const createHrefLangs = (currentAnchorObject) => {
    if (!currentAnchorObject) {
      return [
        <link
          key={currentLanguage}
          rel="alternate"
          hrefLang={currentLanguage}
          href={`${origin}${pathnameLocation}`}
        />,
      ];
    }

    return Object.keys(currentAnchorObject).map(language => (
      <link
        key={language}
        rel="alternate"
        hrefLang={language}
        href={`${origin}/${language}${currentAnchorObject[language]}`}
      />
    ));
  };
  const renderHreflangs = () => {
    const params = LanguageService.getParamsFromPathname(pathname);
    const currentAnchorObject = LanguageService.getAnchorFromPathname(`/${params.slug}`);
    const currentDefaultPath = currentAnchorObject && currentAnchorObject.en;
    const defaultHreflang = currentDefaultPath && `${document.location.origin}${currentDefaultPath}`;

    return [
      ...createHrefLangs(currentAnchorObject),
      defaultHreflang && (
        <link
          key="default"
          rel="alternate"
          hrefLang="x-default"
          href={defaultHreflang}
        />
      ),
    ];
  };

  const renderGlobalMetaTags = () => (
    metaTags
      ? metaTags.metaTags.map(({ system, name, content }) => (
        <meta key={system.id} name={name} content={content} />))
      : null
  );

  return (
    <Helmet defaultTitle="Zonifero" titleTemplate="%s - Zonifero">
      <html lang={currentLanguage} />
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {noIndex && <meta name="robots" content={noIndex} />}
      {title && <meta property="og:title" content={title} />}
      {ogType && <meta property="og:type" content={ogType} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      {metaKeywords && <meta property="keywords" content={metaKeywords} />}
      {description && <meta property="og:description" content={description} />}
      <meta name="twitter:card" content="summary" />
      <link rel="canonical" href={`${origin}${pathnameLocation}`} />
      {renderHreflangs()}
      {renderGlobalMetaTags()}
    </Helmet>
  );
};

InjectMetaTags.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  ogImage: PropTypes.string,
  ogType: PropTypes.string,
  metaKeywords: PropTypes.string,
  noIndex: PropTypes.string,
  pathname: PropTypes.string,
  appStore: PropTypes.instanceOf(AppStore).isRequired,
  globalMetaTagsStore: PropTypes.instanceOf(GlobalMetaTagsStore).isRequired,
};

InjectMetaTags.defaultProps = {
  title: '',
  description: '',
  ogImage: '',
  ogType: '',
  metaKeywords: '',
  noIndex: '',
  pathname: '',
};

export default compose(
  inject('appStore', 'globalMetaTagsStore'),
  observer,
)(InjectMetaTags);



// WEBPACK FOOTER //
// ./src/blocks/InjectMetaTags/index.jsx